module.exports = __webpack_public_path__ + "img/tochi-onyebuchi.3798b7f9.png";